import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { createCurrencyField, createPercentageField, createRadioField, createSelectField, createTextField, StandardDialog } from '@roc/ui';
import AddPricingEconomicsTier from './pricingEconomicsStepper';
import { Grid } from '@material-ui/core';
import { useStore } from '@roc/client-portal-shared/hooks';
import { CompanyProfileStore } from '../../stores/companyProfileStore';

export type PricingEconomicsDefaultFeesProps = {
  companyProfileStore: CompanyProfileStore
};

export const PricingEconomicsDefaultFees = observer((props: PricingEconomicsDefaultFeesProps) => {
  const { companyProfileStore } = props
  const formStore = companyProfileStore.lenderTermTierEconomicsFormStore;

  return (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        {createPercentageField({
          label: 'Yield Spread Premium',
          fieldName: 'yieldSpreadPremium',
          testId: 'yieldSpreadPremium',
          store: formStore,
        })}
      </Grid>
      <Grid item xs={12}>
        {createPercentageField({
          label: 'Term Origination Points',
          fieldName: 'termOriginationPoints',
          testId: 'termOriginationPoints',
          store: formStore,
        })}
      </Grid>
      <Grid item xs={12}>
        {createCurrencyField({
          label: 'Processing Fees',
          fieldName: 'processingFees',
          testId: 'yieldSpreadPremium',
          store: formStore,
        })}
      </Grid>
      <Grid item xs={12}>
        {createCurrencyField({
          label: 'Admin Fees',
          fieldName: 'adminFees',
          testId: 'adminFees',
          store: formStore,
        })}
      </Grid>
      <Grid item xs={12}>
        {createCurrencyField({
          label: 'Underwriting Fees',
          fieldName: 'underwriterFees',
          testId: 'underwriterFees',
          store: formStore,
        })}
      </Grid>
      <Grid item xs={12}>
        {createCurrencyField({
          label: 'Commitment Fees',
          fieldName: 'commitmentFees',
          testId: 'commitmentFees',
          store: formStore,
        })}
      </Grid>
      <Grid item xs={12}>
        {createCurrencyField({
          label: 'Buydown Fees',
          fieldName: 'buydownFees',
          testId: 'buydownFees',
          store: formStore,
        })}
      </Grid>
    </Grid>
  );
});

export default PricingEconomicsDefaultFees;
